import { ThemeSetting } from '@shared/sdk-v1/models';

const colorToRgbValues = (color: string | null | undefined): string | null => {
  if (!color) return null;
  if (color.startsWith('#')) {
    let hex = color.slice(1);
    if (hex.length === 3) {
      hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
    }
    if (hex.length === 6) {
      const r = parseInt(hex.substring(0, 2), 16);
      const g = parseInt(hex.substring(2, 4), 16);
      const b = parseInt(hex.substring(4, 6), 16);
      return `${r} ${g} ${b}`;
    }
  }
  const rgbMatch = color.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
  if (rgbMatch) {
    return `${rgbMatch[1]} ${rgbMatch[2]} ${rgbMatch[3]}`;
  }

  console.warn(`Invalid or unsupported color format provided: "${color}"`);
  return null;
};

export const useTheme = () => {
  const setThemeColors = (themeSetting: ThemeSetting) => {
    const root = document.documentElement;

    const themeMap: Record<string, string | null | undefined> = {
      '--primary-color': themeSetting.primaryColor,
      '--primary-text-color': themeSetting.primaryTextColor,
      '--secondary-color': themeSetting.secondaryColor,
      '--secondary-text-color': themeSetting.secondaryTextColor,
      '--error-color': themeSetting.errorColor,
      '--error-text-color': themeSetting.errorTextColor,
      '--warning-color': themeSetting.warningColor,
      '--warning-text-color': themeSetting.warningTextColor,
      '--background-color': themeSetting.backgroundColor,
      '--background-text-color': themeSetting.backgroundTextColor,
    };

    for (const [property, color] of Object.entries(themeMap)) {
      const rgbValue = colorToRgbValues(color);
      if (rgbValue) {
        root.style.setProperty(property, rgbValue);
      } else {
        root.style.removeProperty(property);
      }
    }
  };

  return {
    setThemeColors,
  };
};
